<template>
  <main class="l-main p-register p-plan">
    <div class="l-block">
      <PaymentLocalNav />
      <TitleRegister>
        <Progress :items="progress" />
      </TitleRegister>
      <div class="l-block__content">
        <div class="hTitle">
          <h1>ご利用プランを選択してください。</h1>
        </div>
        <ul class="p-plan-list">
          <li v-if="isTrial" class="p-plan-list__item">
            <h3 class="p-plan-list__title">トライアル</h3>
            <div class="p-plan-list__content">
              <p class="p-plan-list__price"><span>0</span>円</p>
              <ul class="p-plan-usage-list">
                <li class="p-plan-usage-list__item">
                  サイト流入の重要指標表示
                </li>
                <li class="p-plan-usage-list__item">指名、一般ワード分類</li>
                <li class="p-plan-usage-list__item">獲得キーワード分析機能</li>
                <li class="p-plan-usage-list__item">
                  検索ボリューム・傾向取得
                </li>
                <li class="p-plan-usage-list__item">
                  順位定点観測と順位変動履歴を毎日取得
                </li>
                <li class="p-plan-usage-list__item">重要ページのSEO評価機能</li>
                <li class="p-plan-usage-list__item">
                  競合キーワードの順位と流入数
                </li>
              </ul>
              <Button
                variant="main"
                fsize="f14"
                block
                class="l-mt-3"
                :class="{ 'is-loading': isProcessing }"
                :disabled="isProcessing"
                @click="submitTrial"
              >
                このプランにする
              </Button>
            </div>
          </li>
          <template v-else>
            <li class="p-plan-list__item">
              <h3 class="p-plan-list__title">ベーシック</h3>
              <div class="p-plan-list__content">
                <p class="p-plan-list__price"><span>50,000</span>円/月(税抜)</p>
                <ul class="p-plan-usage-list">
                  <li class="p-plan-usage-list__item">
                    サイト流入の重要指標表示
                  </li>
                  <li class="p-plan-usage-list__item">指名、一般ワード分類</li>
                  <li class="p-plan-usage-list__item">
                    獲得キーワード分析機能
                  </li>
                  <li class="p-plan-usage-list__item">
                    検索ボリューム・傾向取得
                  </li>
                  <li class="p-plan-usage-list__item">
                    順位定点観測と順位変動履歴を毎日取得
                  </li>
                  <li class="p-plan-usage-list__item">
                    重要ページのSEO評価機能
                  </li>
                  <li class="p-plan-usage-list__item">
                    競合キーワードの順位と流入数
                  </li>
                </ul>
                <Button
                  variant="main"
                  fsize="f14"
                  block
                  class="l-mt-3"
                  @click="submit('starter')"
                >
                  このプランにする
                </Button>
              </div>
            </li>
            <li class="p-plan-list__item">
              <h3 class="p-plan-list__title">スタンダード</h3>
              <div class="p-plan-list__content">
                <p class="p-plan-list__price">
                  <span>150,000</span>円/月(税抜)
                </p>
                <ul class="p-plan-usage-list">
                  <li class="p-plan-usage-list__item">
                    サイト流入の重要指標表示
                  </li>
                  <li class="p-plan-usage-list__item">指名、一般ワード分類</li>
                  <li class="p-plan-usage-list__item">
                    獲得キーワード分析機能
                  </li>
                  <li class="p-plan-usage-list__item">
                    検索ボリューム・傾向取得
                  </li>
                  <li class="p-plan-usage-list__item">
                    順位定点観測と順位変動履歴を毎日取得
                  </li>
                  <li class="p-plan-usage-list__item">
                    重要ページのSEO評価機能
                  </li>
                  <li class="p-plan-usage-list__item">
                    競合キーワードの順位と流入数
                  </li>
                </ul>
                <Button variant="main" fsize="f14" block class="l-mt-3">
                  このプランにする
                </Button>
              </div>
              <div class="p-plan-list__comingsoon">
                <p>随時リリース予定</p>
              </div>
            </li>
            <li class="p-plan-list__item">
              <h3 class="p-plan-list__title">プレミアム</h3>
              <div class="p-plan-list__content">
                <p class="p-plan-list__price">
                  <span>300,000</span>円/月(税抜)
                </p>
                <ul class="p-plan-usage-list">
                  <li class="p-plan-usage-list__item">
                    サイト流入の重要指標表示
                  </li>
                  <li class="p-plan-usage-list__item">指名、一般ワード分類</li>
                  <li class="p-plan-usage-list__item">
                    獲得キーワード分析機能
                  </li>
                  <li class="p-plan-usage-list__item">
                    検索ボリューム・傾向取得
                  </li>
                  <li class="p-plan-usage-list__item">
                    順位定点観測と順位変動履歴を毎日取得
                  </li>
                  <li class="p-plan-usage-list__item">
                    重要ページのSEO評価機能
                  </li>
                  <li class="p-plan-usage-list__item">
                    競合キーワードの順位と流入数
                  </li>
                </ul>
                <Button variant="main" fsize="f14" block class="l-mt-3">
                  このプランにする
                </Button>
              </div>
              <div class="p-plan-list__comingsoon">
                <p>随時リリース予定</p>
              </div>
            </li>
          </template>
        </ul>
        <Alert v-if="request.error" class="l-mt-4">
          {{ request.error }}
        </Alert>
      </div>
    </div>
  </main>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Progress from '@/components/Progress';
import PaymentLocalNav from '@/components/payment/PaymentLocalNav';
import TitleRegister from '@/components/TitleRegister';
import apiOrgs from '@/api/orgs';

export default {
  components: {
    Alert,
    Button,
    Progress,
    PaymentLocalNav,
    TitleRegister
  },
  data() {
    return {
      progress: [
        {
          current: true,
          label: 'プランの選択'
        },
        {
          label: 'お支払い方法の選択'
        },
        {
          label: 'カード情報の入力'
        }
      ],
      request: {
        error: ''
      },
      isProcessing: false
    };
  },
  computed: {
    isAgent() {
      return this.$store.getters['user/isAgent'];
    },
    isTester() {
      return this.$store.state.user.status.isTester;
    },
    isTrial() {
      return this.$store.state.user.status.isTrial;
    }
  },
  watch: {
    error: {
      handler() {
        this.checkError();
      },
      deep: true
    }
  },
  created() {
    if (this.isTrial) {
      // トライアルプランの場合は「プランの選択」のステップしかないので、ステップを表示しない
      this.progress = [];
    } else if (!this.isAgent) {
      // 代理店ではない場合は「お支払い方法の選択」のステップがなくなる
      this.progress.splice(1, 1);
    }
  },
  methods: {
    submit(plan) {
      let planId = {
        starter: 'ed4wa'
      };
      if (process.env.VUE_APP_ENV === 'production' && this.isTester) {
        planId = {
          starter: '9fha6'
        };
      }
      const params = {
        planId: planId[plan]
      };
      this.$store.dispatch('payment/setParams', params);

      if (this.isAgent) {
        this.$router.push({ name: 'paymentSelect' });
      } else {
        this.$router.push({ name: 'paymentCard' });
      }
    },
    submitTrial() {
      if (this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      apiOrgs.subscriptions.trial
        .post(this.auth.idToken)
        .then(response => {
          this.$store.dispatch('user/getPlan').finally(() => {
            this.$router.push({ name: 'projects' });
          });
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.request.error = error.response.data.errors[0].userMessage;
          }
          this.isProcessing = false;
        });
    }
  }
};
</script>
